import { useState } from 'react';
import { useChat } from './ChatContext';
import WinLogoWhiteForChat from '../../../src/assets/images/logo-win-white.svg'; // Your Chat Window Component
import { useDispatch, useSelector } from "react-redux";
import axios from 'axios';
import { Endpoints } from "../../Global/Endpoints";

const FloatingChatButton = () => {
  const { showChat } = useChat();
  const isLoggedIn = useSelector((state) => state.login.isAuthenticated);
  const userInfo  = useSelector((state) => state.userData);
  const dispatch = useDispatch();
  const token = localStorage.getItem('AccessToken');
  const hasExpired = localStorage.getItem('sessionExpired') === 'true';
  console.log({isLoggedIn,  userInfo})
  const [chatCount, setChatCount] = useState(userInfo?.userData?.ChatCount || 0);
  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";

    // Function to log activity
    const logChatActivity = async () => {
      const params = {
        EmailID: userInfo?.userData?.EmailID,
        Activity: "WINChat",
        DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
      };
      
      try {
        const response = await axios.post(
          Endpoints.CallRecoderLog,
          { _Params: JSON.stringify(params) },
          {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Connection": "close",
            "Accept": "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

  if (response.data) {
    console.log("Log saved successfully:",response.data);
  
  } else {
    console.warn("Log not saved: Empty response from server.");
  }

} catch (error) {
  console.error("Error saving log:", error);
}
};
  
    // Handle chat button click
    const handleChatButtonClick = () => {
      logChatActivity(); // Save log to the endpoint
      showChat(); // Show chat window
      setChatCount(0);
      dispatch({
        type: "UPDATE_USER_DATA", 
        payload: { ...userInfo.userData, ChatCount: 0,  },
      });
    };
    // debugger
    console.log("chat visiblity",isLoggedIn, token, userInfo?.userData?.WINChat, hasExpired, isHighmarkPortal)
  if(!isLoggedIn || !token || userInfo?.userData?.WINChat === "N" || userInfo?.userData?.WINChat !== "Y" || hasExpired ||isHighmarkPortal) return <></>
  return (
    <>
      {/* Floating Button */}
      <div className="floating-chat-button" onClick={handleChatButtonClick}>
        {isHighmarkPortal ? 
         <span style={{ marginBottom: '12px' }}>Chat</span>
        :
         <>
         <img src={WinLogoWhiteForChat} alt="" className="win-chat-logo" />
          <span>Chat</span>
         </> 
        }
        {chatCount > 0 && (<span className="chat-btn-notification-number">{chatCount}</span>)}
      </div>
    </>
  );
};

export default FloatingChatButton;